/*
 * @Autor: lmlss
 * @Date: 2023-09-25 13:21:08
 * @Description:
 * @LastEditors: lmlss
 * @LastEditTime: 2024-08-27 21:51:12
 */
import { CommonFile, axios } from "marmot_design_ui";

export interface iCreateNoticeReq {
  noticeId?: string;
  title: string;
  parseUserIds: string[];
  copy2UserIds: string[];
  info: string;
  commonFileList: CommonFile[];
  commonMediaList: CommonFile[];
  receiveScope: any;
  noticeTypeId: string;
  receiveType: "READ" | "BUTTON" | "SIGN";
  tagType: "EMERGENT" | "NORMAL";
  smsFlag: boolean;
  smsText: string;
  fixedTimeType: "FIX" | "IMMEDIATELY";
  fixedTime: string;
  noticeSendType: "CLASS" | "SCHOOL" | "OTHER";
  noticeSendClient: "PC" | "MAPP";
}

const prefixUrl = "/phoenix/msg/api";
// const prefixUrl = "http://39.97.248.73:18829/mock/769";

export const getFixTimeNotice = () => {
  return axios.request({
    url: prefixUrl + "/v2/pc/notice/mgr/getFixTimeNotice",
    method: "get",
  });
};

export const getNoticeTypeSelector = () => {
  return axios.request({
    url: prefixUrl + "/v2/notice/common/getNoticeTypeSelector",
    method: "get",
  });
};

export const queryResult = (params: {
  pageNumber: number;
  pageSize: number;
  noticeId: string;
  resultViewType: "NORMAL_UN_DEAL" | "NORMAL_DEAL" | "COPY_" | string;
}) => {
  return axios.request({
    url: prefixUrl + "/v2/pc/notice/mgr/queryResult",
    method: "post",
    data: params,
  });
};

export const queryNoticeList = (data: {
  pageNumber?: number;
  pageSize?: number;
  titleSearch?: string;
  timeUnitSearch?: {
    startTime: string;
    endTime: string;
  };
  msgTypeSearchId?: string;
  noticeTimeType?: "FIX" | "IMMEDIATELY" | string;
  noticeSendType?: "CLASS" | "SCHOOL" | "OTHER" | string;
  owenType?: "CREATE" | "COPY" | "CANCEL" | string;
}) => {
  return axios.request({
    url: prefixUrl + "/v2/pc/notice/person/query",
    method: "post",
    data,
  });
};

export const queryNoticedDetail = (params: { noticeId: string }) => {
  return axios.request({
    // url: prefixUrl + "/v2/pc/notice/person/detailM",
    url: "/phoenix/msg/api/v2/pc/msgcenter/usernotice/getNoticeDetail",
    method: "get",
    params,
  });
};

export const saveNoticeToTemplate = (data: { noticeId: string }) => {
  return axios.request({
    url: prefixUrl + "/v2/pc/notice/mgr/template",
    method: "post",
    data,
  });
};

export const cancelNotice = (data: { noticeId: string }) => {
  return axios.request({
    url: prefixUrl + "/v2/pc/notice/mgr/cancel",
    method: "post",
    data,
  });
};

export const publishNotice = (data: Partial<iCreateNoticeReq>) => {
  return axios.request({
    url: prefixUrl + "/v2/pc/notice/mgr/publish",
    method: "post",
    data,
  });
};

export const queryTypeList = (data: {
  pageNumber?: number;
  pageSize?: number;
  noticeSendType?: "CLASS" | "SCHOOL" | "OTHER" | string;
  enableFlag?: boolean | string;
}) => {
  return axios.request({
    url: prefixUrl + "/v2/pc/notice/type/mgr/query",
    method: "post",
    data,
  });
};

export const parseUser = (data: any) => {
  return axios.request({
    url: prefixUrl + "/v2/notice/common/parseUser",
    method: "post",
    data,
  });
};

export const checkUser = (data: { importUserNos: string[] }) => {
  return axios.request({
    url: prefixUrl + "/v2/notice/common/checkUser",
    method: "post",
    data,
  });
};

export const queryTemplates = (params) => {
  return axios.request({
    url: prefixUrl + "/v2/pc/notice/template/mgr/query",
    method: "post",
    data: params,
  });
};

export const getTemplateDetail = (params) => {
  return axios.request({
    url: prefixUrl + "/v2/pc/notice/template/mgr/detail",
    method: "get",
    params,
  });
};

export const getRedPoint = () => {
  return axios.request({
    url: prefixUrl + "/v2/notice/common/getRedPoint",
    method: "get",
  });
};

export const deleteTemplate = (params) => {
  return axios.request({
    url: prefixUrl + "/v2/pc/notice/template/mgr/delete",
    method: "post",
    data: params,
  });
};

export const operationTemplate = (params) => {
  return axios.request({
    url: prefixUrl + "/v2/pc/notice/template/mgr/save",
    method: "post",
    data: params,
  });
};

export const excelOutput = (noticeId) => {
  return axios.request({
    url: prefixUrl + "/v2/pc/notice/excel/excelOutput",
    method: "get",
    params: { noticeId },
  });
};

export const getNoticePoint = () => {
  return axios.request({
    url: prefixUrl + "/v2/pc/notice/person/getNoticePoint",
    method: "get",
  });
};

export const dealNotice = ({ noticeId }) => {
  return axios.request({
    url: prefixUrl + "/v2/pc/notice/person/deal",
    method: "post",
    data: { noticeId },
  });
};

export const readAllNotice = () => {
  return axios.request({
    url: prefixUrl + "/v2/pc/notice/person/readAll",
    method: "post",
    data: {},
  });
};

//  TODO: 临时测试用接口
export const mgrSearch = (data: {
  pageNumber?: number;
  pageSize?: number;
  noticeSendType?: "CLASS" | "SCHOOL" | "OTHER" | string;
  enableFlag?: boolean | string;
}) => {
  return axios.request({
    url: "https://api-test.dbxiao.cn/galaxy/papercenter/api/develop/pageCategory/thirdCategory/mgrSearch",
    method: "post",
    data,
  });
};

export const enableType = (data: { typeId: string; enableFlag: boolean }) => {
  return axios.request({
    url: prefixUrl + "/v2/pc/notice/type/mgr/enable",
    method: "post",
    data,
  });
};

export const operationType = (data: {
  typeId?: string;
  name: string;
  noticeSendType: string;
  sortSeq: number;
}) => {
  return axios.request({
    url: prefixUrl + "/v2/pc/notice/type/mgr/save",
    method: "post",
    data,
  });
};

export const getSendUserType = (noticeType = "SCHOOL") => {
  return axios.request({
    url: prefixUrl + "/v1/pc/msgcenter/noticeSender/getSendUserType",
    method: "get",
    params: { noticeType },
  });
};
